import { Drawer, DrawerProps } from 'antd';

export type DrawerAtomProps = DrawerProps;

const DrawerAtom = Drawer;

export default DrawerAtom;